var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 24 25"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Layer_2",
            "data-name": "Layer 2",
            transform: "translate(0)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Logo_Mark",
                "data-name": "Logo Mark",
                transform: "translate(0 0)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Logo_mark-2",
                    "data-name": "Logo mark",
                    transform: "translate(0 0)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      id: "Path_2178",
                      "data-name": "Path 2178",
                      d:
                        "M11.99,0a12,12,0,1,0,12,12,12,12,0,0,0-12-12ZM7.89,9.319H9.616v2.122c-2.414,0-2.96,0-3.325.935H4.151A3.473,3.473,0,0,1,7.89,9.319Zm4.558,4.987c0,2.5-1.885,3.39-4.056,3.39-2.738,0-4.31-1.18-4.31-4.618H6.2c-.037,2.414,1.012,2.768,2.193,2.768a1.8,1.8,0,0,0,1.942-1.924v-8.8h2.114Zm4.134,3.308c-1.326.038-.983.024-1.292.024V15.6c1.307,0,2.8-.018,2.8-2.09s-1.391-2.072-2.8-2.072-2.131-.01-2.131-.01V9.319s2.072.01,3.425.01c1.332,0,3.522.9,3.522,4.181S17.9,17.58,16.582,17.614Z",
                      transform: "translate(0.01 0.4)",
                      fill: "#19a"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b23842e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b23842e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/icons/JG_Logo.vue
// module id = fOSX
// module chunks = 1